module.exports = __webpack_public_path__ + "img/1.4797ed5b.png";